import React from 'react'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AuthHeaderUserMenuItem = ({ title, icon, route, tabIndex }) => (
  <a href={route} target="_blank" rel="noopener noreferrer">
    <hot-dropdown-menu-item slot="menu" class={`${styles.headerUserItem}`} tabIndex={tabIndex}>
      <FontAwesomeIcon icon={icon} className="_text-gray-700 _mr-4" />
      <p className="_m-0 _flex-1">{title}</p>
    </hot-dropdown-menu-item>
  </a>
)

export default AuthHeaderUserMenuItem
